<template>
  <div id="Player">
    <div class="topText">• Barq •</div>
    <div class="bottomText">barq was created by Stefan Doblhofer 2020</div>
    <div v-if="msg" id="messages">
      {{ msg }}
    </div>
    <!-- <div v-if="playerStatus == 'not ready'" id="outer_FirstStartupPopUp">
      <div id="FirstStartupPopUp">
        <p>{{ t("Input_playerName") }}</p>
        <input type="text" v-model="userName" />
        <button class="pointer" @click="submitName">
          {{ t("submitName") }}
        </button>
      </div>
    </div> -->
    <div v-if="playerStatus == 'ready' && spielPhase == -1" class="waiting">
      {{ t("waiting for start") }}
    </div>
    <RoundPopUp :gamePhase="room.gamePhase" :sprache="sprache" />
    <TotalRevenue
      v-if="spielPhase >= 0"
      :toBeat="room.toBeat || 0"
      :totalRevenue="room.totalRevenue || 0"
      :gamePhase="spielPhase"
      :sellingPrice="room.sellingPrice"
      :sellingList="room.sellingList"
      :sprache="sprache"
      :deactivate_barq="room.gamePhase.hack.barqul || 'on'"
      @digits="digits"
    />
    <BarqGrid
      v-if="spielPhase >= 0"
      ref="BarqGrid"
      :sellingList="room.sellingList"
      :gamePhase="room.gamePhase || {}"
      :barqs="room.barqs"
      :token="token"
      :sprache="sprache"
      :firewall="room.firewall || {}"
      :userName="userName"
      :resetCounter="resetCounter"
      @msg="setMessage"
      @addToPlayerData="addToPlayerData"
      @resetCounter="resetCounterIncrement"
    />
    <Telebarq
      v-if="spielPhase >= 0"
      :telebarqs="telebarqs"
      :sprache="sprache"
      :showPopUp="showPopUp"
      :userName="userName"
      @resetPopUp="resetPopUp"
      @msg="setMessage"
      @addToPlayerData="addToPlayerData"
    />
    <div id="version">v7</div>
    <div id="UserName" @click="changeSprache" class="pointer">
      {{ userName }} : {{ sprache }}
    </div>
    <div class="not_supported">
      <p class="main_support">Sorry - you need a bigger screen to play Barq!</p>
      <div class="support_image_holder">
        <img class="tablet" src="../assets/tablet.png" alt="" />
        <div>→</div>
        <img class="tablet rotate" src="../assets/tablet.png" alt="" />
      </div>

      <p class="lower_support">
        (Using a tablet? Try holding it horizontally!)
      </p>
    </div>
  </div>
</template>

<script>
import DeviceDetector from "device-detector-js";

import BarqGrid from "./BarqGrid.vue";
import TotalRevenue from "./TotalRevenue.vue";
import Telebarq from "./Telebarq.vue";
import Dict from "../../services/dict_new.js";
import RoundPopUp from "./RoundPopUp.vue";
// import { gzip, ungzip } from "node-gzip";

export default {
  name: "Player",
  components: {
    BarqGrid,
    TotalRevenue,
    Telebarq,
    RoundPopUp,
  },
  watch: {
    room: function (newVal, oldVal) {
      // watch it
      console.log("inside room WATCHER");
      console.log(newVal.gamePhase);
      console.log(oldVal.gamePhase);

      if (!newVal.players || !oldVal.players) return;
      if (!newVal.players[this.userId] || !oldVal.players[this.userId]) return;
      console.log("inside room WATCHER 2");
      try {
        let oldPlayer = oldVal.players[this.userId].telebarqs;
        let newPlayer = newVal.players[this.userId].telebarqs;
        console.log(oldPlayer);
        console.log(newPlayer);
        console.log("inside room WATCHER inside try");
        if (newPlayer.length != oldPlayer.length) {
          console.log("TELEBARQ change");
          console.log(newPlayer[newPlayer.length - 1]);
          this.showPopUp = true;
          // this.openTelebarq(newPlayer.at(-1));
        }
        if (newPlayer.reset) {
          this.resetPlayer();
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
  data() {
    return {
      sprache: "english",
      Buch: {},
      token: this.$route.query.token,
      userName: "",
      userId: null,
      msg: "",
      msgTimer: null,
      room: {
        gamePhase: {},
        sellingList: {},
        firewall: {},
        totalRevenue: 0,
      },
      spielPhase: -1,
      room_playerSpecificData: [],
      playerStatus: "not ready",
      gameStatus: "stopped",
      imgData: null,
      // currentOpenBarq: "",
      // currentOpenBarq_Codes: "",
      telebarqs: [],
      // sampleTurnover: this.room.totalRevenue,
      showPopUp: false,
      resetCounter: 0,
      device: {},
    };
  },

  methods: {
    resetPopUp() {
      this.showPopUp = false;
    },
    t(word) {
      return Dict(word, this.sprache);
    },
    changeSprache() {
      if (this.sprache == "deutsch") {
        this.sprache = "english";
      } else {
        this.sprache = "deutsch";
      }
    },
    resetCounterIncrement() {
      console.log("resetCounterIncrement");
      if (this.resetCounter == -1) {
        this.resetCounter++;
      }
      this.resetCounter++;
      console.log(this.resetCounter);
    },
    resetPlayer() {
      this.playerStatus = "not ready";
      let queryOLD = this.$route.query;
      this.$router.replace({
        query: queryOLD,
      });
    },
    randId() {
      const alphabet =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890";
      let id = "";
      for (let i = 0; i < 10; i++) {
        id += alphabet.charAt(Math.floor(Math.random() * alphabet.length));
      }
      return id;
    },
    digits(digits) {
      if (!this.$refs) {
        this.setMessage(this.t("could not find barq"));
        return;
      }
      this.$refs.BarqGrid.digits(digits);
    },
    // checkCookie() {
    //   let c = this.getCookie();
    //   console.log(c);
    //   if (!c) return false;
    //   if (c.userId && c.roomCode == this.room.id) {
    //     console.log("cookie found, id " + c.userId);
    //     console.log(c);
    //     // this.id = c.id
    //     this.userId = c.userId;
    //     if (c.roomCode == this.room.id) {
    //       this.userName = c.userName;
    //     }
    //     return c;
    //   } else {
    //     console.log("NO cookie/ correct cookie found");
    //     return false;
    //   }
    // },
    // setCookie() {
    //   this.$router.push({
    //     query: {
    //       ...this.$route.query,
    //       roomCode: this.room.id,
    //       userId: this.userId,
    //       userName: this.userName,
    //     },
    //   });
    //   console.log("new cookie was set with parameters: ");
    //   // console.log(obj);
    //   return true;
    // },
    // getCookie() {
    //   let obj = {
    //     roomCode: this.roomCode,
    //     userId: this.userId,
    //     userName: this.userName,
    //   };
    //   return obj;
    // },
    submitName() {
      console.log("registerPlayer");
      this.userId = this.randId();
      this.createNewUser();
    },
    setMessage(msg) {
      this.msg = msg;
      if (this.msgTimer) {
        clearTimeout(this.msgTimer);
      }
      this.msgTimer = setTimeout(() => {
        this.msg = "";
      }, 3000);
    },
    checkToken() {
      this.$http
        .post("/checkToken", {
          token: this.token,
        })
        .then((res) => {
          console.log(res);
          if (res.status === 200) {
            this.setMessage(res.data.msg);
            if (res.data.type == "success") {
              this.room = res.data.room; //Grundstruktur
              // this.userType = res.data.decoded.userType;
              // this.userId = res.data.userId;

              if (res.data.name) {
                this.userName = res.data.name;
                this.submitName();
                console.log("starting INTERVAL");
                //user war schonmal hier, passt alles, kann gleich weiterarbeiten
                this.playerStatus = "ready";
                // this.createInterval();
              }
              console.log("token success");
              // console.log(t('submitName'))

              return true;
            }
          } else {
            this.setMessage(
              "cannot connect to server, please check your connection or reload the page"
            );
            // this.setMessage('error bei der Verbindung zum Server, versuchen sie es erneut, checken sie die Internetverbindung...')
            return false;
          }
        });
    },
    // startGame() {
    //   //Gm hast started the game
    //   this.gameStatus = "playing";
    // },
    // setSampleData(data) {
    //   try {
    //     this.sampleBarqs[data.name].status = data.status;
    //   } catch (e) {
    //     console.log(e);
    //   }
    //   if (data.sampleTurnover) this.sampleTurnover += data.sampleTurnover;
    // },
    addToPlayerData(data) {
      for (var i = 0; i < this.room_playerSpecificData.length; i++) {
        if (data.barqId) {
          if (this.room_playerSpecificData[i].barqId == data.barqId) {
            this.room_playerSpecificData[i] = data;
            return true;
          }
        }
        if (data.teleId) {
          if (this.room_playerSpecificData[i].teleId == data.teleId) {
            this.room_playerSpecificData[i] = data;
            return true;
          }
        }
      }
      console.log("yes2");
      this.room_playerSpecificData.push(data);
      console.log(this.room_playerSpecificData);
      return true;
    },
    // reSetUser() {
    //   this.userName = "";
    //   this.userId = null;
    //   if (this.$cookie.isCookieAvailable("barq")) {
    //     console.log("cookie found");
    //     this.$cookie.removeCookie("barq", {
    //       path: "/",
    //       domain: "",
    //     });
    //   }
    //   this.playerStatus = "not ready";
    // },
    createInterval() {
      setInterval(() => {
        // console.log("STARGING UPDATEROOM!!!!!!!!!!!!!!!!!!!!!!!!!!");
        this.$http
          .post("/updateRoom", {
            token: this.token, //damit wissen wir schon die credentials und den richtigen Raum
            // room:this.room,
            player: this.userName,
            currentEntry: this.room.currentEntry,
            playerSpecificData: this.room_playerSpecificData,
          })
          .then((res) => {
            // console.log(res);
            if (res.status === 200 && res.data.type == "success") {
              // console.log(res.data.reSetUser + "==" + this.userId);
              // if (res.data.reSetUser == this.userId) {
              //   this.reSetUser();
              // }

              if (res.data.emptyRoom) {
                // console.log("success, updateRoom, NO new Data");
                return true;
              }

              // console.log("new Data*************************************");
              this.room = res.data.room;
              // console.log(this.room.sellingList);
              // console.log(this.room.gamePhase);
              try {
                // console.log(this.userId);
                // console.log(this.room.players[this.userId]);
                this.telebarqs = this.room.players[this.userId].telebarqs;
                // console.log(this.telebarqs);
              } catch (e) {
                console.log("failed to load telebarqs form user " + e);
              }
              try {
                this.spielPhase = this.room.gamePhase.phase;
              } catch (e) {
                console.log(e);
              }

              this.room_playerSpecificData = [];
              // console.log("success, updateRoom, new Data");
              return true;
            } else if (res.status === 200 && res.data.type == "failure") {
              try {
                this.setMessage(res.data.msg);
              } catch (e) {
                console.log(e);
              }
            }
            return false;
            // this.serverStatus.curr++
          });
      }, 1000);
    },
    createNewUser() {
      this.$http
        .post("/createUser", {
          token: this.token, //damit wissen wir schon die credentials und den richtigen Raum
          name: this.userName,
          userId: this.userId,
          device: this.device,
        })
        .then((res) => {
          this.setMessage(res.data.msg);
          if (res.status === 200 && res.data.type == "success") {
            console.log("success COOKIE SET AND SERVER KNOWS IT");

            if (res.data.id) {
              this.userId = res.data.id;
            }
            // if (this.setCookie()) this.playerStatus = "ready";
            this.createInterval();
            return true;
          }
          // if(res.data.type=='failure'){
          //   this.setMessage("User could not be created, please try again")
          // }
          return false;
          // this.serverStatus.curr++
        });
    },
  },
  created() {
    let userAgent = window.navigator.userAgent;
    this.device = new DeviceDetector().parse(userAgent);
    // window.onbeforeunload = function () {
    //   return "Are you sure?";
    // };
    this.checkToken();
    this.$http
      .post("/updateRoom", {
        token: this.token, //damit wissen wir schon die credentials und den richtigen Raum
        currentEntry: -1,
      })
      .then((res) => {
        console.log(res);
        if (res.status === 200 && res.data.type == "success") {
          console.log("success, updateRoom");

          this.room = res.data.room;
          try {
            this.telebarqs = this.room.players[this.userId].telebarqs;
            console.log(this.telebarqs);
          } catch (e) {
            console.log("failed to load telebarqs form user " + e);
          }
          try {
            this.spielPhase = this.room.gamePhase.phase;
            this.resetCounter = this.room.gamePhase.phase;
            console.log("RESETCOUNTER =: " + this.resetCounter);
          } catch (e) {
            console.log(e);
          }

          console.log("new Data");

          // this.load_alleAufgaben();

          return true;
        }
        return false;
      });
    // this.$honeybadger.notify("HELLO first error");
  },
  filters: {
    numberFilter: function (n) {
      return parseInt(n).toLocaleString("de-DE");
    },
  },
};
</script>

<style scoped>
img {
  width: 100%;
  border-radius: 15px;
}

.pointer:hover {
  cursor: pointer;
}

.waiting {
  margin: 3em auto;
  font-size: 2em;
  text-align: center;
  line-height: 2em;
}

#UserName {
  position: fixed;
  bottom: 0px;
  left: 0px;
}

.topText {
  position: absolute;
  top: -21px;
  color: white;
}

.bottomText {
  position: absolute;
  bottom: -21px;
  color: white;
}

#Player:before {
  border: 4px solid white;
  content: "";
  width: calc(100% + 26px);
  height: calc(100% + 48px);
  position: absolute;
  top: -28px;
  left: -17px;
  border-radius: 27px;
  pointer-events: none;
}

#Player {
  display: flex;
  position: relative;
  max-height: 636px;
  justify-content: center;
  margin-top: max(3%, 30px) !important;
  border-radius: 30px;
  margin: 30px 0px;
  padding: 20px 0;
  max-width: min(90%, 1500px);
  margin: 0 auto;
  box-shadow: -20px 30px 0 0px var(--barq-orange),
    -20px -30px 0 0px var(--barq-orange), 20px 30px 0px 0px var(--barq-orange),
    20px -30px 0 0px var(--barq-orange);
  min-height: 70%;
  background: #f2f2f2;
}

#FirstStartupPopUp {
  background: #1860b9;
  width: 50%;
  margin: 3em auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

#outer_FirstStartupPopUp {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  position: fixed;
  z-index: 3;
  height: 100%;
  backdrop-filter: grayscale(1) blur(3px);
}

#FirstStartupPopUp > p {
  font-size: 1.5em;
  color: white;
}

#FirstStartupPopUp > button {
  margin: 10px;
}

#FirstStartupPopUp > input {
  margin: 0px;
  width: 200px;
  text-align: center;
}

#main {
  width: 900px;
  margin: 0 auto;
}

#messages {
  font-size: 1.6em;
  padding: 10px;
  position: fixed;
  z-index: 4;
  background: white;
  top: 0px;
}

.Barqulator {
  text-align: center;
  font-size: 2.5em;
  color: white;
  margin-bottom: 10px;
}

p {
  margin: 1em;
}

input {
  width: 80px;
  height: 40px;
  font-size: 2em;
  margin-left: 20px;
  border: 0px;
}

button {
  height: 42px;
  border: 1px solid white;
  background: none;
  color: white;
  margin-left: 50px;
}

button:hover {
  background: white;
  color: var(--barq-orange);
}

#version {
  position: fixed;
  right: 0px;
  bottom: 0px;
}

.not_supported {
  display: none;
}

.not_supported > p {
  background: white;
}
.tablet {
  width: 50px !important;
  border-radius: 0px !important;
  height: intrinsic;
}

.rotate {
  transform: rotate(90deg);
}

.support_image_holder {
  display: flex;
  flex-wrap: nowrap;
  width: 200px;
  justify-content: space-around;
  line-height: 69px;
}

.lower_support {
  font-size: 25px;
}

@media only screen and (max-width: 1020px) {
  .not_supported {
    display: flex;
    position: fixed;
    justify-content: center;
    text-align: center;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 5;
    font-size: 30px;
    align-items: center;
    background: white;
    flex-wrap: wrap;
    flex-direction: column;
  }
}
</style>
